import { RawButton } from '../../../CommonComponents/OPL/Button/Button.styles';
import styled from '../../../theme/theme';

export const AccountHeaderWrapper = styled(RawButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.space['12'],
  paddingBottom: theme.space['12'],
  paddingLeft: theme.space['4'],
  paddingRight: theme.space['4'],
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
  width: '100%',
}));
